import { render, staticRenderFns } from "./tileButtonBlock.vue?vue&type=template&id=49879c75"
import script from "./tileButtonBlock.vue?vue&type=script&lang=js"
export * from "./tileButtonBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports